/**
 * Capitalizes the first letter of a string
 * @param string - The string to capitalize
 * @returns The string with the first letter capitalized
 *
 * @example
 * capitalizeFirstLetter('hello') // 'Hello'
 */
export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
